import { messaging } from "../firebase";
import { getToken, onMessage } from "firebase/messaging";
import { addDeviceToken } from "../service/employeeService";

// Request Notification Permission and Get Token
export const requestPermission = async () => {
  try {
    // Request notification permission from the user
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted.");
      return;
    }

    console.log("Notification permission granted.");

    const adminData = localStorage.getItem("admin");
    let userId;
    if (adminData) {
      try {
        const parsedData = JSON.parse(adminData);
        const userData = JSON.parse(parsedData?.auth)?.user;
        userId = userData?.id;
      } catch (error) {
        console.error("Error parsing localStorage data:", error);
      }
    } else {
      console.warn("No admin data found in localStorage.");
    }

    const storedTokenData = JSON.parse(localStorage.getItem("fcmTokenData"));
    const isTokenValid =
      storedTokenData && new Date(storedTokenData.expiry) > new Date();

    if (!userId) {
      console.warn("No userId available — skipping device token registration.");
      return;
    }

    if (isTokenValid) {
      await sendTokenToServer(userId, storedTokenData.token);
    } else {
      const token = await getToken(messaging, {
        // vapidKey: process.env.REACT_APP_VAPID_KEY,
        vapidKey: process.env.REACT_APP_YOUR_VAPID_KEY,
      });

      if (token) {
        const tokenData = {
          token,
          expiry: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
        };
        localStorage.setItem("fcmTokenData", JSON.stringify(tokenData));
        await sendTokenToServer(userId, token);
      } else {
        console.warn(
          "No registration token available. Request permission to generate one.",
        );
      }
    }
  } catch (error) {
    console.error("An error occurred while retrieving token:", error);
  }
};

// Send Token to Server
const sendTokenToServer = async (userId, token) => {
  try {
    const response = await addDeviceToken(userId, { deviceToken: token });

    if (response.success) {
      // Token sent successfully
    } else {
      console.error("Failed to send token to server:", response.statusText);
    }
  } catch (error) {
    console.error("Error sending token to server:", error);
  }
};

// Listener for Incoming FCM Messages (foreground only)
//
// Chat-related notifications (DM, channel) are handled exclusively by the
// intercom (chat) app at intercom.sapientcodelabs.xyz.
// Firing them here in the portal would cause duplicate browser notifications
// from a different origin.
export const onMessageListener = () => {
  onMessage(messaging, (payload) => {
    // Suppress chat-related FCM messages — intercom app handles these
    if (payload.data?.chatType || payload.data?.chatId) {
      console.log(
        "[Portal FCM] Suppressed chat notification — handled by intercom app",
      );
      return;
    }

    // Display a notification for non-chat incoming messages
    const { title, body, icon } = payload.notification || {};

    function cleanBody(htmlString) {
      if (!htmlString) return "";
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      return doc.body.textContent.trim();
    }

    new Notification(title || "New Message", {
      body: cleanBody(body) || "You have a new notification.",
      icon: icon || "/default-icon.png",
    });
  });
};

// NotificationConstructor — kept as export for backward compatibility.
// Browser notifications for chat messages are now handled exclusively by the
// intercom (chat) app. This function only updates unread-count state when
// called, but does NOT fire a browser notification.
export function NotificationConstructor(message, url = "/home/chat") {
  // No-op: browser notifications are handled by intercom app.
  // This export is preserved so existing imports do not break.
  return;
}
